module.exports = __webpack_public_path__ + "img/icon-repo.fa4f3a7e.png";